import {
  arrayBuilderItemFirstPageTitleUI,
  textUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  PolicyOrGroupTitle,
  TricarePolicyDescription,
} from '../../../components/FormDescriptions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';
import { validatePolicyNumber } from '../../../utils/validation';

const TITLE_TEXT = content['insurance-info--policy-title'];
const INPUT_LABELS = {
  provider: content['insurance-info--provider-label'],
  policyholder: content['insurance-info--policyholder-label'],
  policyNum: content['insurance-info--policy-number-label'],
  groupCode: content['insurance-info--group-code-label'],
};
const HINT_TEXT = {
  policyNum: content['insurance-info--policy-number-hint'],
  groupCode: content['insurance-info--group-code-hint'],
};
const ERR_MSGS = {
  provider: {
    required: content['insurance-info--provider-error-message'],
    pattern: content['insurance-info--provider-error-message'],
  },
  policyholder: {
    required: content['insurance-info--policyholder-error-message'],
    pattern: content['insurance-info--policyholder-error-message'],
  },
  policyNum: {
    required: content['insurance-info--policy-number-error-message'],
    pattern: content['insurance-info--policy-number-error-message'],
  },
  groupCode: {
    required: content['insurance-info--group-code-error-message'],
    pattern: content['insurance-info--group-code-error-message'],
  },
};

const { providers } = FULL_SCHEMA.properties;
const policy = providers.items.properties;

export default {
  uiSchema: {
    ...arrayBuilderItemFirstPageTitleUI({
      title: TITLE_TEXT,
      showEditExplanationText: false,
    }),
    insuranceName: textUI({
      title: INPUT_LABELS.provider,
      errorMessages: ERR_MSGS.provider,
    }),
    insurancePolicyHolderName: textUI({
      title: INPUT_LABELS.policyholder,
      errorMessages: ERR_MSGS.policyholder,
    }),
    'view:policyNumberOrGroupCode': {
      ...titleUI({
        title: PolicyOrGroupTitle,
        headerLevel: 2,
        classNames: 'vads-u-margin-top--3 vads-u-margin-bottom--0',
      }),
      insurancePolicyNumber: textUI({
        title: INPUT_LABELS.policyNum,
        hint: HINT_TEXT.policyNum,
        description: TricarePolicyDescription,
        errorMessages: ERR_MSGS.policyNum,
      }),
      insuranceGroupCode: textUI({
        title: INPUT_LABELS.groupCode,
        hint: HINT_TEXT.groupCode,
        errorMessages: ERR_MSGS.groupCode,
      }),
      'ui:validations': [validatePolicyNumber],
    },
  },
  schema: {
    type: 'object',
    required: [
      'insuranceName',
      'insurancePolicyHolderName',
      'view:policyNumberOrGroupCode',
    ],
    properties: {
      insuranceName: policy.insuranceName,
      insurancePolicyHolderName: policy.insurancePolicyHolderName,
      'view:policyNumberOrGroupCode': {
        type: 'object',
        properties: {
          insurancePolicyNumber: policy.insurancePolicyNumber,
          insuranceGroupCode: policy.insuranceGroupCode,
        },
      },
    },
  },
};
